var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSg = function SvgIconSg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.304 6.261a3.65 3.65 0 0 1 2.87-3.567 3.652 3.652 0 1 0 0 7.135 3.65 3.65 0 0 1-2.87-3.568M12 2.87l.258.797h.839l-.678.493.259.797-.679-.493-.678.493.26-.797-.679-.493h.839z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.966 4.435.26.797h.837l-.678.493.26.797-.679-.493-.678.493.26-.797-.679-.493h.838zM14.033 4.435l.259.797h.838l-.678.493.259.797-.678-.493-.678.493.259-.797-.679-.493h.839zM13.25 6.783l.26.798h.838l-.679.492.26.797-.678-.492-.679.492.26-.797-.679-.492h.838zM10.749 6.783l.259.798h.838l-.678.492.259.797-.678-.492-.679.492.26-.797-.679-.492h.838z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconSg;